
define('text!modules/shared/templates/searchBoxGrid.html',[],function () { return '<div class="item {{^isActive}}inactive{{/isActive}} {{#isCurrent}}currentItem{{/isCurrent}}" data-id="{{id}}">\n    <div class="column"><div class="truncate">{{name}}</div></div>\n</div>';});

